import {request_post} from './request'
import {BASE_URL} from './config'

const API_BASE= BASE_URL

export const register = (data) => {
  const url = `${API_BASE}/chat/register`
  return request_post(url, data)
}

export const login = (data) => {
  const url = `${API_BASE}/chat/login`
  return request_post(url, data)
}

export const queryConversation = (data) => {
  const url = `${API_BASE}/chat/queryConversation`
  return request_post(url, data)
}

export const queryOneConversation = (data) => {
  const url = `${API_BASE}/chat/queryOneConversation`
  return request_post(url, data)
}

export const addConversation = (data) => {
  const url = `${API_BASE}/chat/addConversation`
  return request_post(url, data)
}

export const updateStatus = (data) => {
  const url = `${API_BASE}/chat/updateConversationStatus`
  return request_post(url, data)
}

export const offlineMessages = (data) => {
  const url = `${API_BASE}/chat/findOfflineMessages`
  return request_post(url, data)
}

export const deleteOfflineMessages = (data) => {
  const url = `${API_BASE}/chat/deleteOfflineMessages`
  return request_post(url, data)
}

export const findMessages = (data) => {
  const url = `${API_BASE}/chat/findMessages`
  return request_post(url, data)
}



// WEBPACK FOOTER //
// ./src/common/im/api.js